if (!customElements.get('tp-product-price')) {
  customElements.define('tp-product-price', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('tp-product-picker, tp-main-product');
      if (!this.root) return;
      this.price = this.querySelector('[data-tp-price]');
      this.compare = this.querySelector('[data-tp-compare]');
      this.pill = this.querySelector('[data-tp-pill]');
      this.saved = this.querySelector('[data-tp-saved]');
      const variants = JSON.parse(this.root.querySelector('[data-tp-variants]')?.textContent || '[]');
      const id = this.root.querySelector('[data-tp-variant-input]')?.value;
      this.variant = variants.find((variant) => String(variant.id) === id);
      this.onVariant = (event) => {
        this.variant = event.detail;
        this.signature = null;
        this.update();
      };
      this.root.addEventListener('tp:price-change', this.onVariant);
      this.observer = new MutationObserver(() => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      });
      this.root.querySelectorAll('[data-tp-price-app]').forEach((app) => {
        this.observer.observe(app, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'bucks-currency', 'bucks-current'] });
      });
      this.update();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.root?.removeEventListener('tp:price-change', this.onVariant);
    }

    amount(node) {
      const money = node?.querySelector('.money');
      const text = (node?.textContent || '').trim();
      const match = text.match(/^(.*?)(\d[\d\s.,'’]*)(.*?)$/);
      if (!match) return null;
      const number = match[2].trim();
      const currency = money?.getAttribute('bucks-currency') || this.dataset.currency;
      const precision = new Intl.NumberFormat('en', { style: 'currency', currency }).resolvedOptions().maximumFractionDigits;
      const tail = number.match(/([.,])(\d+)$/);
      const decimals = tail && tail[2].length <= precision ? tail[2].length : 0;
      const decimal = decimals ? tail[1] : null;
      const integer = decimals ? number.slice(0, -decimals - 1) : number;
      const group = integer.match(/[^\d]/)?.[0];
      const value = Number(integer.replace(/\D/g, '') + (decimals ? '.' + tail[2] : ''));
      return { value, decimals, decimal, group, currency, prefix: match[1], suffix: text.slice(match[1].length + number.length) };
    }

    saving(price, compare) {
      const current = this.amount(price);
      const original = this.amount(compare);
      if (!current || !original || current.currency !== original.currency || original.value <= current.value) return '';
      const decimals = Math.max(current.decimals, original.decimals);
      const decimal = current.decimal || original.decimal || '.';
      const group = current.group || original.group || (decimal === ',' ? '.' : ',');
      const number = new Intl.NumberFormat(current.currency === 'INR' ? 'en-IN' : 'en-US', {
        minimumFractionDigits: decimals, maximumFractionDigits: decimals,
      }).format(original.value - current.value).replace(/[.,]/g, (separator) => separator === '.' ? decimal : group);
      return current.prefix + number + current.suffix;
    }

    update() {
      const selected = this.root.querySelector('[data-tp-price-app] .kaching-bundles__bar--selected');
      this.root.dispatchEvent(new CustomEvent('tp:bundle-update', { detail: { bar: selected } }));
      const price = selected?.querySelector('.kaching-bundles__bar-price');
      const compare = selected?.querySelector('.kaching-bundles__bar-full-price');
      if (price?.textContent.trim()) {
        const signature = JSON.stringify([price.innerHTML, compare?.innerHTML]);
        if (signature === this.signature) return;
        this.signature = signature;
        this.price.innerHTML = price.innerHTML;
        this.compare.innerHTML = compare?.innerHTML || '';
        const saved = this.saving(price, compare);
        this.compare.hidden = !saved;
        if (this.pill) this.pill.hidden = !saved;
        if (this.saved) this.saved.textContent = saved;
        return;
      }
      const variant = this.variant;
      if (!variant || this.signature === variant.id) return;
      this.signature = variant.id;
      this.price.innerHTML = variant.price;
      this.compare.innerHTML = variant.compare || '';
      this.compare.hidden = !variant.compare;
      if (this.pill) this.pill.hidden = !variant.compare;
      if (this.saved) this.saved.innerHTML = variant.saved || '';
      window.bucksCC?.reConvert?.();
    }
  });
}

if (!customElements.get('tp-bundle-image')) {
  customElements.define('tp-bundle-image', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('tp-product-picker, tp-main-product');
      this.images = [this.root.slides[0]?.querySelector('img'), this.root.thumbs[0]?.querySelector('img')].filter(Boolean);
      this.original = this.images.map((image) => ({ src: image.getAttribute('src'), srcset: image.getAttribute('srcset'), alt: image.getAttribute('alt') }));
      this.onBundle = (event) => this.select(event.detail.bar);
      this.root.addEventListener('tp:bundle-update', this.onBundle);
      this.select(this.root.querySelector('.kaching-bundles__bar--selected'));
    }

    disconnectedCallback() {
      this.root.removeEventListener('tp:bundle-update', this.onBundle);
      this.select(null);
    }

    select(bar) {
      if (!bar) {
        if (this.key) this.images.forEach((image, index) => {
          Object.entries(this.original[index]).forEach(([name, value]) => {
            if (value !== null) image.setAttribute(name, value);
            else image.removeAttribute(name);
          });
        });
        this.key = null;
        return;
      }
      const quantity = bar.querySelectorAll('.kaching-bundles__bar-variant-main').length
        || Number(bar.querySelector('.kaching-bundles__bar-title')?.textContent.match(/\d+/)?.[0]);
      const key = `${bar.dataset.dealBarId}:${quantity}`;
      if (key === this.key || !this.getAttribute(`data-image-${quantity}`)) return;
      const url = new URL(this.getAttribute(`data-image-${quantity}`), document.baseURI);
      url.searchParams.set('width', '1200');
      this.key = key;
      this.images.forEach((image) => {
        image.removeAttribute('srcset');
        image.src = url.href;
      });
      this.images[0].alt = this.getAttribute(`data-alt-${quantity}`) || this.original[0].alt;
      this.root.show(0);
    }
  });
}
